import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSFormLayoutBlockItemName = 'DSFormlayoutblockitem';

export const DSFormLayoutBlockItemSlots = {
  CONTAINER: 'container',
  LABEL: 'label',
  MESSAGE: 'message',
  ERROR_MESSAGE: 'error-message',
  COUNTER: 'counter',
  MARK: 'mark',
};

export const DSFormLayoutBlockItemDataTestId = slotObjectToDataTestIds(
  DSFormLayoutBlockItemName,
  DSFormLayoutBlockItemSlots,
);
